<template>
  <nav class="navigation">
    <router-link v-for="item in items"
                 :key="item.path"
                 :to="item.path"
                 ref="nav-item"
                 class="nav-item anim-opacity"
                 active-class="active">
      {{item.text}}
    </router-link>
    <span class="underline" :class="{hidden:  activeItem === -1}" :style="activeLink"></span>
  </nav>
</template>

<script>
  export default {
    props: {
      vertical: {
        type: Boolean,
        required: false
      },
      items: {
        type: Array,
        required: true
      }
    },
    name: "Navigation",
    data: () => ({
      activeLink: {
        left: 0,
        width: 0
      },
      activeItem: 0
    }),
    watch: {
      "vertical": function () {
        this.findActiveLink(this.$route.path)
      }
    },
    methods: {
      findActiveLink: function (toRoute) {
        let items = this.items;
        let itemFound = false;
        for (let index = 0; index < items.length; index++) {
          let item = items[index];
          if (item.path === toRoute) {
            this.activeItem = index;
            let ref = this.$refs["nav-item"];
            if (ref && ref.length > 0) {
              let itemLink = ref[index].$el;
              if (this.vertical) {
                this.activeLink = {
                  top: `${itemLink.offsetTop}px`,
                  height: `${itemLink.offsetHeight}px`
                };
              } else {
                this.activeLink = {
                  left: `${itemLink.offsetLeft}px`,
                  width: `${itemLink.offsetWidth}px`
                };
              }
              itemFound = true;
              break;
            }
          }
        }

        if (!itemFound) {
          this.activeItem = -1;
        }
      }
    },
    mounted: function () {
      this.$router.onReady(() => {
        this.findActiveLink(this.$route.path)
      });
      this.$router.afterEach((to) => {
        this.findActiveLink(to.path)
      });
      window.addEventListener("resize", () => {
        this.findActiveLink(this.$route.path)
      });
    }
  }
</script>
